import React from 'react';

/**
 * Shared utility function to render input sections consistently across all car input components
 * Replaces duplicated renderInputSection functions in BuyInputs, FinanceInputs, LeaseInputs, etc.
 */
export const renderInputSection = (title: string, children: React.ReactNode) => (
  <div className="input-section">
    <h3>{title}</h3>
    <div className="input-grid">
      {children}
    </div>
  </div>
);
